<template>
    <q-page class="q-pa-md">

        <q-dialog class="rounded-borders" v-model="dialogContrato" persistent>
            <q-card style="width: 1200px; max-width: 80vw;" class="shadow-0">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Contrato Anterior</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <q-card class="shadow-0" v-if="nuevoContratoAnterior">
                        <q-card-section>
                            <div class="row q-col-gutter-sm">
                                <div class="col-12">
                                    <q-select outlined v-model="selectCliente" :options="clientes" label="Cliente"
                                        option-label="rfc" option-value="_id_cliente" dense required emit-value
                                        map-options>
                                        <template v-slot:option="scope">
                                            <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                                <q-item-section avatar>
                                                    <q-icon name="mdi-account" color="priamry" />
                                                </q-item-section>
                                                <q-item-section>
                                                    <q-item-label
                                                        v-html="scope.opt.rfc + ' ' + scope.opt.razon_social" />
                                                </q-item-section>
                                            </q-item>
                                        </template>
                                    </q-select>
                                </div>
                                <div class="col-12 col-md-12">
                                    <q-select outlined v-model="auto" :options="listaCarros" label="Automovil"
                                        option-label="placa" option-value="_id" dense required emit-value map-options>
                                        <template v-slot:option="scope">
                                            <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                                <q-item-section avatar>
                                                    <q-icon name="mdi-car" color="priamry" />
                                                </q-item-section>
                                                <q-item-section>
                                                    <q-item-label
                                                        v-html="scope.opt.placa + ' ' + scope.opt.estadoplaca + ' ' + scope.opt.numeroserie" />
                                                </q-item-section>
                                            </q-item>
                                        </template>
                                    </q-select>
                                </div>
                                <div class="col-12 col-md-12">
                                    <q-input dense v-model="nuevoContratoAnterior.nregistro" outlined
                                        label="No. Registro" required />
                                </div>
                                <div class="col-12 col-md-6">
                                    <q-input v-model="nuevoContratoAnterior.representante" outlined
                                        label="Apoderada Legal" dense required />
                                </div>
                                <div class="col-12 col-md-6">
                                    <q-input readonly v-model="nuevoContratoAnterior.puesto" outlined
                                        label="Puesto/Cargo" dense required />
                                </div>
                                <div class="col-12 col-md-3">
                                    <q-select v-model="nuevoContratoAnterior.plazos" dense outlined label="Plazos"
                                        :options="itemsPlazos" option-label="label" option-value="value" emit-value
                                        map-options class="full-width">
                                    </q-select>
                                </div>
                                <div class="col-12 col-md-3">
                                    <q-input prefix="$" dense v-model="montotoralvehiculo" outlined
                                        label="Monto total del Vehiculo" required mask="#.##" fill-mask="0"
                                        reverse-fill-mask input-class="text-right" />
                                </div>
                                <div class="col-12 col-md-3">
                                    <q-input prefix="$" dense v-model="mensualidad" outlined label="Mensualidad"
                                        required mask="#.##" fill-mask="0" reverse-fill-mask input-class="text-right" />
                                </div>
                                <div class="col-12 col-md-3">
                                    <q-input prefix="$" dense v-model="pinicial" outlined label="Pago Inicial" required
                                        mask="#.##" fill-mask="0" reverse-fill-mask input-class="text-right" />
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-input prefix="$" dense v-model="pagoresidual" outlined label="Pago Residual"
                                        required mask="#.##" fill-mask="0" reverse-fill-mask input-class="text-right" />
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-select v-model="nuevoContratoAnterior.mensualidades" outlined
                                        label="Mensualidades" dense required :options="mensualidades" />
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-select v-model="nuevoContratoAnterior.mensualidadesrestantes" outlined
                                        label="Mensualidades Restantes" dense required :options="mensualidades" />
                                </div>
                                <div class="col-12 col-md-4">
                                    <!-- <q-input class="q-ma-none q-pa-none" dense outlined
                                        v-model="nuevoContratoAnterior.fechainiciocontrato"
                                        label="Fecha de Inicio de Contrato" mask="date" bottom-slots
                                        placeholder="yyyy/MM/dd">
                                        <template v-slot:append>
                                            <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                            </q-icon>
                                        </template>
                                    </q-input> -->

                                    <q-input class="q-ma-none q-pa-none q-mr-sm" dense outlined
                                        v-model="nuevoContratoAnterior.fechainiciocontrato"
                                        label="Fecha de Inicio de Contrato" mask="date" bottom-slots
                                        placeholder="yyyy/MM/dd">
                                        <template v-slot:append>
                                            <q-icon name="event" class="cursor-pointer q-ma-none q-pa-none">
                                                <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy"
                                                    transition-show="scale" transition-hide="scale">
                                                    <q-date class="q-ma-none q-pa-none"
                                                        v-model="nuevoContratoAnterior.fechainiciocontrato">
                                                        <div class="q-ma-none q-pa-none row items-center justify-end">
                                                            <q-btn class="q-ma-none q-pa-none" v-close-popup label="Ok"
                                                                color="primary" flat />
                                                        </div>
                                                    </q-date>
                                                </q-popup-proxy>
                                            </q-icon>
                                        </template>
                                    </q-input>
                                </div>
                                <div class="col-12 col-md-4">
                                    <!-- <q-input class="q-ma-none q-pa-none" dense outlined
                                        v-model="nuevoContratoAnterior.fechapago" label="Fecha de Pago" mask="date"
                                        bottom-slots placeholder="yyyy/MM/dd">
                                        <template v-slot:append>
                                            <q-icon name="event" class="q-ma-none q-pa-none">
                                            </q-icon>
                                        </template>
                                    </q-input> -->

                                    <q-input class="q-ma-none q-pa-none q-mr-sm" dense outlined
                                        v-model="nuevoContratoAnterior.fechapago" label="Fecha de pago" mask="date"
                                        bottom-slots placeholder="yyyy/MM/dd">
                                        <template v-slot:append>
                                            <q-icon name="event" class="cursor-pointer q-ma-none q-pa-none">
                                                <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy"
                                                    transition-show="scale" transition-hide="scale">
                                                    <q-date class="q-ma-none q-pa-none"
                                                        v-model="nuevoContratoAnterior.fechapago">
                                                        <div class="q-ma-none q-pa-none row items-center justify-end">
                                                            <q-btn class="q-ma-none q-pa-none" v-close-popup label="Ok"
                                                                color="primary" flat />
                                                        </div>
                                                    </q-date>
                                                </q-popup-proxy>
                                            </q-icon>
                                        </template>
                                    </q-input>
                                </div>
                                <div class="col-12 col-md-4">
                                    <!-- <q-input class="q-ma-none q-pa-none" dense outlined
                                        v-model="nuevoContratoAnterior.fechafacturacion" label="Fecha de Facturación"
                                        mask="date" bottom-slots placeholder="yyyy/MM/dd">
                                        <template v-slot:append>
                                            <q-icon name="event" class="q-ma-none q-pa-none">
                                            </q-icon>
                                        </template>
                                    </q-input> -->

                                    <q-input class="q-ma-none q-pa-none q-mr-sm" dense outlined
                                        v-model="nuevoContratoAnterior.fechafacturacion" label="Fecha de Facturación"
                                        mask="date" bottom-slots placeholder="yyyy/MM/dd">
                                        <template v-slot:append>
                                            <q-icon name="event" class="cursor-pointer q-ma-none q-pa-none">
                                                <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy"
                                                    transition-show="scale" transition-hide="scale">
                                                    <q-date class="q-ma-none q-pa-none"
                                                        v-model="nuevoContratoAnterior.fechafacturacion">
                                                        <div class="q-ma-none q-pa-none row items-center justify-end">
                                                            <q-btn class="q-ma-none q-pa-none" v-close-popup label="Ok"
                                                                color="primary" flat />
                                                        </div>
                                                    </q-date>
                                                </q-popup-proxy>
                                            </q-icon>
                                        </template>
                                    </q-input>

                                </div>
                            </div>
                        </q-card-section>
                        <q-card-actions class="row justify-between">
                            <q-btn flat color="red" label="Cerrar" v-close-popup />
                            <q-btn flat color="primary" label="Crear Contrato" @click="PostContrato()" />
                        </q-card-actions>
                    </q-card>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog v-model="dialogVisualizador" persistent>
            <q-card style="width: 1200px; max-width: 80vw;" class="shadow-0">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Vista previa PDF</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <div class="text-center">
                        <q-btn icon="download" flat label="Descargar PDF" color="primary" @click="descargarPDF" />
                    </div>
                    <VisualizadorPDF></VisualizadorPDF>
                </q-card-section>
            </q-card>
        </q-dialog>

        <div class="row q-pt-md q-col-gutter-md">
            <div class="col-12">
                <q-table dense title="Contratos" class="shadow-1" :data="dataList" :loading="loading" :columns="columns"
                    color="primary" row-key="_id" :pagination="initialPagination">
                    <template v-slot:top-right>


                        <q-btn outline color="primary" icon="mdi-refresh" label="Consultar" @click="GetContratos()"
                            no-caps class="q-my-md q-mr-sm " />
                        <q-btn outline color="primary" icon="mdi-plus" label="SUBIR CONTRATO" class="q-my-md"
                            @click="nuevoItem()" />
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props" class="hover-fila">
                            <q-td key="nregistro" :props="props" @click="verItem(props.row)">{{ props.row.nregistro
                                }}</q-td>
                            <q-td key="nombre" :props="props" @click="verItem(props.row)">{{ props.row.nombre }}</q-td>
                            <q-td key="plazos" :props="props" @click="verItem(props.row)">{{ props.row.plazos }}</q-td>
                            <q-td key="vehiculo" :props="props" @click="verItem(props.row)">{{ props.row.marca + " " +
                                props.row.modelo + " " + props.row.color }}</q-td>
                            <q-td key="nserie" :props="props" @click="verItem(props.row)">{{ props.row.nserie }}</q-td>
                            <q-td key="nmotor" :props="props" @click="verItem(props.row)">{{ props.row.nmotor }}</q-td>
                            <q-td key="montotoralvehiculo" :props="props" @click="verItem(props.row)">{{
                                formatoMonedaMexicana(props.row.montotoralvehiculo) }}</q-td>
                            <q-td key="fechacontrato" :props="props" @click="verItem(props.row)">{{
                                formatearFecha(props.row.fechacontrato) }}</q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>
    </q-page>
</template>
<script>
import axios from "axios";
import { QSpinnerClock } from 'quasar'
import VisualizadorPDF from "../../PDF/VisualizadorContrato.vue";
import moment from 'moment';
export default {
    components: {
        VisualizadorPDF
    },
    data() {
        return {
            loading: false,
            dataList: [],
            columns: [
                { name: 'nregistro', label: 'Registro', field: 'nregistro', align: 'center', sortable: true },
                { name: 'nombre', label: 'Cliente', field: 'nombre', align: 'center', sortable: true },
                { name: 'plazos', label: 'Plazos', field: 'concepto', align: 'center', sortable: true },
                { name: 'vehiculo', label: 'Vehiculo', field: 'monto', align: 'center', sortable: true },
                { name: 'nserie', label: 'N. Serie', field: 'tipo', align: 'center', sortable: true },
                { name: 'nmotor', label: 'N. Motor', field: 'fechacreacion', align: 'center', sortable: true },
                { name: 'montotoralvehiculo', label: 'Monto Total del Vehiculo', field: 'fechamaximapago', align: 'center', sortable: true },
                { name: 'fechacontrato', label: 'Fecha de contrato', field: 'fechacontrato', align: 'center', sortable: true },
            ],
            initialPagination: {
                sortBy: 'nombre',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            dialogVisualizador: false,
            selectContrato: null,

            //CONTRATO ANTERIOR
            dialogContrato: false,
            nuevoContratoAnterior: null,
            clientes: [],
            listaCarros: [],
            auto: '',
            selectCliente: '',
            mensualidades: Array.from({ length: 49 }, (_, i) => i),
            itemsPlazos: [
                { label: '12 Meses', value: '12' },
                { label: '24 Meses', value: '24' },
                { label: '36 Meses', value: '36' },
                { label: '48 Meses', value: '48' },
            ],
            mensualidad: 0,
            montotoralvehiculo: 0,
            pagoresidual: 0,
            pinicial: 0
        }
    },
    async mounted() {
    },
    computed: {
        adminStore() {
            return this.$store.state.auth.usuario;
        },
    },
    created() {
        this.GetContratos(),
            this.GetClientes();

    },

    methods: {
        async verItem(item) {
            console.log(item)
            this.selectContrato = item
            this.$store.state.auth.objetoContrato = item
            this.dialogVisualizador = true
        },

        async GetContratos() {
            this.loading = true
            try {
                let respuesa = await axios.get('Contratos/GetCcontratoList/')
                console.log(respuesa)
                this.dataList = respuesa.data.lista
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },

        formatoMonedaMexicana(valor) {
            return valor.toLocaleString('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },

        formatearFecha(isoString) {
            const fecha = new Date(isoString);

            const dia = String(fecha.getUTCDate()).padStart(2, '0');
            const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0');
            const anio = fecha.getUTCFullYear();

            const hora = String(fecha.getUTCHours()).padStart(2, '0');
            const minutos = String(fecha.getUTCMinutes()).padStart(2, '0');
            const segundos = String(fecha.getUTCSeconds()).padStart(2, '0');

            return `${dia}/${mes}/${anio} ${hora}:${minutos}:${segundos}`;
        },

        descargarPDF() {
            const fileName = 'CONTRATO_' + this.selectContrato.nregistro + this.selectContrato.nombre + '.pdf';
            const link = document.createElement("a");
            link.href = this.$store.state.auth.storeBase64Contrato;
            link.download = fileName;
            link.click();
        },

        async PostContrato() {
            this.nuevoContratoAnterior.id_cliente = this.selectCliente
            this.nuevoContratoAnterior.id_auto = this.auto
            this.nuevoContratoAnterior.mensualidad = parseFloat(
                Number(this.mensualidad).toFixed(2)
            );
            this.nuevoContratoAnterior.montotoralvehiculo = parseFloat(
                Number(this.montotoralvehiculo).toFixed(2)
            );
            this.nuevoContratoAnterior.pagoresidual = parseFloat(
                Number(this.pagoresidual).toFixed(2)
            );
            this.nuevoContratoAnterior.pinicial = parseFloat(
                Number(this.pinicial).toFixed(2)
            );
            console.log(this.nuevoContratoAnterior)
            if (this.auto == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el auto que se le asignara al contrato.` });
                return
            }
            if (this.selectCliente == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el cliente del contrato.` });
                return
            }

            try {
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Creando contrato. Espere...', messageColor: 'white' })

                const resp = await axios.post(`Contratos/CrearContratoPasado/`, this.nuevoContratoAnterior);
                console.log(resp)

                if (resp.data.edopet == "0") {
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `Se creo correctamente el Contrato.` });
                    this.dialogContrato = false

                } else {
                    this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al crear el contrato. Intentelo de nuevo...` });
                }
                this.$q.loading.hide()
            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al crear el seguro. Intentelo de nuevo...` });
                console.log(error)
            }
        },
        nuevoItem() {
            this.GetAutos();

            this.nuevoContratoAnterior = {
                id_cliente: '',
                id_auto: '',
                nregistro: '',
                plazos: '',
                montotoralvehiculo: 0,
                mensualidad: 0,
                pagoresidual: 0,
                mensualidades: '',
                mensualidadesrestantes: '',
                fechainiciocontrato: '',
                fechapago: '',
                fechafacturacion: '',
                pinicial: 0,
                representante: '',
                puesto: 'APODERADA LEGAL'
            }
            this.dialogContrato = true
        },
        async GetAutos() {
            try {
                let respuesa = await axios.get('Autos/GetAutosListaDisponibles/')
                console.log(respuesa.data)
                this.listaCarros = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetClientes() {
            try {
                let respuesa = await axios.get('Configuracion/GetUsuariosDatosFiscales/')
                console.log(respuesa)
                this.clientes = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
    }
}
</script>
<style>
.hover-fila:hover td {
    cursor: pointer;
    background: #dcf6ff;
}

.doc-note {
    background-color: #f0f4f8;
    /* Fondo claro */
    border-left: 4px solid #007BFF;
    /* Línea de color azul en el borde izquierdo */
    padding: 16px;
    margin: 16px 0;
    border-radius: 8px;
    color: #333;
    /* Color de texto */
    font-family: Arial, sans-serif;
}

.doc-note__title {
    margin: 0 0 8px 0;
    font-weight: bold;
    color: #007BFF;
    /* Mismo tono del borde para coherencia */
    font-size: 16px;
}

.doc-note p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
}
</style>